export default {
  REQUEST: 'REQUEST_CONTENT_GENERATION',
  SUCCESS: 'SUCCESS_CONTENT_GENERATION',
  FAIL: 'FAIL_CONTENT_GENERATION',
  CANCEL: 'CANCEL_CONTENT_GENERATION',
  OPEN_MODAL: 'OPEN_CONTENT_GENERATION_MODAL',
  CLOSE_MODAL: 'CLOSE_CONTENT_GENERATION_MODAL',
  SET_STATUS: 'SET_CONTENT_GENERATION_STATUS'
}
